import { createApiHook } from '../hooks';
import { dynamicReportApiFactory } from './dynamicReportApiFactory';

export const useDynamicReportApi = createApiHook(dynamicReportApiFactory);
